import styled from "styled-components"

export const HomeStyles = styled.div`
  display: flex;
  flex-direction:column;
  justify-content:center;
  
`